// extracted by mini-css-extract-plugin
export var fullGrid = "_23-3";
export var pdpPreviewContainer = "_23-1";
export var previewContainer = "_23-0";
export var togglePreviewContainer = "_23-2";